import { useMemo, type ReactNode } from "react";
import { StyleSheet, Text, View } from "react-native";

import { fontFamily, space, textStyle } from "@passfirst/ui";

import { type Colors, useColors } from "../../theme";

interface Props {
  title: string;
  children: ReactNode;
}

// Reusable settings section wrapper. Each settings surface (Account,
// Appearance, Subscriptions, Session, Danger zone) is a Section with
// a header and arbitrary inline content.
export function Section({ title, children }: Props): JSX.Element {
  const colors = useColors();
  const styles = useMemo(() => makeStyles(colors), [colors]);
  return (
    <View style={styles.section}>
      <Text style={styles.sectionHeader} accessibilityRole="header">
        {title}
      </Text>
      {children}
    </View>
  );
}

function makeStyles(colors: Colors) {
  return StyleSheet.create({
    section: {
      marginBottom: space[8],
      gap: space[3],
    },
    sectionHeader: {
      ...textStyle.label,
      fontFamily: fontFamily.semiBold,
      color: colors.textMuted,
      textTransform: "uppercase",
      letterSpacing: 1.2,
      marginBottom: space[1],
    },
  });
}
